import { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import validator from 'validator';
import { Typography } from '../typography';
import { Button } from '../button';
import { SearchableSelect } from '../select';
import { enqueueSnackbar } from '../snackbar';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useTransferContainerMutation } from '../../hooks';
import { clientYardService } from '../../services';
import { INPUT_ERRORS, MESSAGES } from '../../const';
import { i18n } from '../../i18n';
import { DatePicker, Input } from '../input';
import { momentTimeSec, toIsoDate } from '../../utils';

export const containerTransferModal: any = {};

export const ContainerTransferModal = () => {
  const { mutate } = useTransferContainerMutation();
  const [open, setOpen] = useState(false);
  const [clientName, setClientName] = useState('');
  const clientId = useRef('');
  const [transferredDate, setTransferredDate] = useState(moment());
  const [comment, setComment] = useState('');

  const validators = {
    comment: comment
      ? !validator.isLength(comment, { min: 10, max: 200 })
        ? INPUT_ERRORS.NOT_VALID.COMMENT_LENGTH
        : ''
      : '',
  };

  useEffect(() => {
    containerTransferModal.open = () => {
      clientId.current = '';
      setClientName('');

      setOpen(true);
    };
  }, []);

  const handleClientSelect = (obj: any) => {
    clientId.current = obj.id;
    setClientName(obj.label);
  };

  const handleOnClose = () => {
    Object.keys(containerTransferModal).forEach((key) => {
      if (key !== 'open') delete containerTransferModal[key];
    });
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    containerTransferModal.isSubmitClicked = false;

    const mutateData: any = {
      id: containerTransferModal.containerId,
      clientId: clientId.current,
      transferredDate: toIsoDate(transferredDate),
      comment,
    };

    mutate(mutateData, {
      onSuccess: () => {
        setTransferredDate(moment());
        setComment('');
        setOpen(false);
        containerTransferModal.submitClick();
      },
      onError: () => {
        enqueueSnackbar(MESSAGES.CONTAINERS.ERROR.NOT_TRANSFERRED, 'error');
      },
    });
  };

  return (
    <ModalBase id={'container-transfer-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.containerTransferTitle', { number: containerTransferModal.number })}
        </Typography>
        <SearchableSelect
          selectedOptionLabel={clientName}
          label={i18n.t('label.client') + '*'}
          onSelect={handleClientSelect}
          queryFn={() =>
            clientYardService.assignedClients({
              id: containerTransferModal.yardId,
              disabledClientIds: [containerTransferModal.clientId],
            })
          }
          queryKey={[
            'clients',
            'assigned-clients' + containerTransferModal.yardId + containerTransferModal.clientId,
            'transfer',
          ]}
          selectedAreasEqaul={{ key: 'id', keys: [clientId.current] }}
        />
        <DatePicker
          label={i18n.t('label.from') + '*'}
          data-size={'medium'}
          defaultValue={transferredDate}
          onChange={setTransferredDate}
          minDate={
            momentTimeSec(containerTransferModal.minDate) > momentTimeSec()
              ? moment(containerTransferModal.minDate).add(1, 'day')
              : moment(containerTransferModal.minDate)
          }
          maxDate={moment()}
          withoutClearIcon
        />
        <Input
          label={i18n.t('label.comment')}
          data-size={'medium'}
          defaultValue={comment}
          onChange={(e) => setComment(e.target.value)}
          error={!!validators.comment}
          helperText={validators.comment}
        />
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button
            size={'medium'}
            data-color={'primary'}
            onClick={handleSubmitClick}
            disabled={!clientId.current || !!validators.comment}
          >
            {i18n.t('button.transfer')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
